import { useEffect, useRef } from 'react';

const useUnmount = fn => {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(
    () => {
      return ref.current;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};

export default useUnmount;
